export default __webpack_public_path__ + "static/media/SASRIA Material-Damage-Policy-2026.7245c826.pdf";